import React, {useEffect, useState} from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "../../../../../../ui/Dialog/DialogTitle";
import DialogContent from "../../../../../../ui/Dialog/DialogContent";
import DialogActions from "../../../../../../ui/Dialog/DialogActions";
import Checkbox from "../../../../../../ui/Checkbox";
import Button from "../../../../../../ui/Button";
import AddProgramForm from "../AddProgramForm";
import {addPublishedProgram} from "../../store/send";

const styles = () => ({
  dialog: {
    width: "550px"
  }
});

const AddProgramModal = ({
  open,
  handleClose,
  addPublishedProgram,
  isCreatingProgram,
  createdProgram,
  classes,
  history
}) => {
  const [checked, setChecked] = useState(false);
  const [formData, updateFormData] = useState(null);

  const onConfirm = () => {
    addPublishedProgram(formData);
  }

  const onClose = () => {
    updateFormData(null);
    handleClose();
  };

  useEffect(() => {
    if (createdProgram && createdProgram.success) {
      updateFormData(null);
      handleClose();

      if (checked) {
        history.push(`/work/app/manage/resources/programs/myprograms/${createdProgram.id}`);
      }
    }
  }, [createdProgram]);

  return (
    <div>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        PaperProps={{
          className: classes.dialog
        }}
      >
        <DialogTitle onClose={onClose}>Добавить программу</DialogTitle>
        <DialogContent>
          <AddProgramForm onFormChange={updateFormData}
                          disabled={isCreatingProgram}/>
        </DialogContent>
        <DialogActions>
          <Checkbox
            label="Открыть форму для редактирования"
            checked={checked}
            handleChange={() => setChecked(!checked)}
          />
          <Button onClick={handleClose}>Отмена</Button>
          <Button
            loading={isCreatingProgram}
            disabled={isCreatingProgram}
            onClick={() => onConfirm()}
            color="green"
          >
            Добавить
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const mapStateToProps = state => ({
  isCreatingPlan: state.programs.isCreatingPlan,
  createdProgram: state.programs.createdProgram
});

const mapDispatchToProps = dispatch => ({
  addPublishedProgram: (data) => dispatch(addPublishedProgram(data))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withRouter(AddProgramModal)));
